import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  CanMatchFn,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { SweetAlertService } from '../services/sweetalert.service';
import { storageHelper } from '../misc/storage.misc';
import { jwtTokenIdentifier, userIdentifier } from '../misc/utilities.misc';

@Injectable({
  providedIn: 'root'
})

class PermissionsService {

  constructor(
    private router: Router,
    private authService: AuthService,
    private sweetAlertService: SweetAlertService
    ) {}

  private logoutUnauthorizedUser(): UrlTree {
    storageHelper.local.remove(`${jwtTokenIdentifier}`);
    storageHelper.local.remove(`${userIdentifier}`);
    this.sweetAlertService.toastWarning(
      'Acces refuse',
      5000,
      'Vous n etes pas autorise a acceder au dashboard trader.'
    );
    return this.router.createUrlTree(['/auth/signin']);
  }

  canMatch(route: Route, segments: UrlSegment[]): | boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const targetUrl = `/${segments.map((segment) => segment.path).join('/')}`;

    if (!this.authService.isAuthenticated) {
      return this.router.createUrlTree(['/auth/signin'], {
        queryParams: { returnUrl: targetUrl || '/dashboard' }
      });
    }

    if (!this.authService.hasRole('user')) {
      return this.logoutUnauthorizedUser();
    }

    return true;
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): | boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (!this.authService.isAuthenticated) {
      return this.router.createUrlTree(['/auth/signin'], {
        queryParams: { returnUrl: state.url }
      });
    }

    if (!this.authService.hasRole('user')) {
      return this.logoutUnauthorizedUser();
    }

    return true;
  }


  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): | boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (!this.authService.isAuthenticated) {
      return this.router.createUrlTree(['/auth/signin'], {
        queryParams: { returnUrl: state.url }
      });
    }

    if (!this.authService.hasRole('user')) {
      return this.logoutUnauthorizedUser();
    }

    return true;
  }
}

export const DashGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): | boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> => {
  return inject(PermissionsService).canActivate(next, state);
}

export const DashMatchGuard: CanMatchFn = (route: Route, segments: UrlSegment[]): | boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> => {
  return inject(PermissionsService).canMatch(route, segments);
}


export const canActivateChild: CanActivateChildFn = ( next: ActivatedRouteSnapshot, state: RouterStateSnapshot ): | boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> => {
    return inject(PermissionsService).canActivateChild(next, state);
};
